export class PackageListModel {
    packageId: string;
    name: string;

    constructor(packageId: string, name: string) {
        this.packageId = packageId;
        this.name = name;
    }
}
